import React from 'react';

import { Button, Text } from '@BICE_Vida/components';

import Image from 'next/image';
import { Container } from '../../../designSystem';
import Section from '../../Section';

import styles from './BenefitsCircle.module.scss';

import componentsId from '../../../utils/componentsId';
import { benefitsPageTexts } from '../../../utils/generalTexts';

import { BENEFITS_BELIV, BENEFITS_CIRCLE } from '../../../utils/assets';
import { bicevidaURLHealthBenefits } from '@/utils/constants';

const BenefitsCircle = () => {
  const handleLinkClick = () => {
    window.open(bicevidaURLHealthBenefits, '_blank');
  };

  return (
    <Section id={componentsId.benefits.circle.section} customClass={styles.benefits_circle_section}>
      <Container className={styles.benefits_circle_container}>
        <div>
          <Image src={BENEFITS_BELIV.LOGO} height={36} width={104} alt="Beliv by bice" />
          <Text className={styles.benefits_circle_title}>{benefitsPageTexts.circleTitle}</Text>
        </div>

        <div className={styles.benefits_circle_cards_container}>
          {benefitsPageTexts.circleList.map(({ name, image, background }, index) => (
            <div key={name + index} className={styles.benefits_circle_card_container}>
              <div className={styles.benefits_circle_card} style={{ background }}>
                <Image src={image} height={40} width={40} alt="" />
              </div>
              <div className={styles.benefits_circle_card_name}>
                <Text className={styles.benefits_circle_card_name_text}>{name}</Text>
              </div>
            </div>
          ))}
        </div>
        <Button
          className={styles.benefits_circle_button}
          variant="outline"
          text={benefitsPageTexts.circleBtn}
          onClick={handleLinkClick}
        />
      </Container>
    </Section>
  );
};

export default BenefitsCircle;
